import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";
import type { Album } from "@libs/wire";
import { timestamps } from "../utils/fields";

// Per-entity-ID durable cache for album wire shape. Mirrors `cached_songs`
// — see that file for design notes. Single-column PK on albumId.
export const cachedAlbums = sqliteTable("cached_albums", {
  ...timestamps,
  albumId: text("album_id").primaryKey(),
  data: text("data", { mode: "json" }).notNull().$type<Album>(),
  fetchedAt: integer("fetched_at", { mode: "timestamp_ms" }).notNull(),
});

export type CachedAlbumRow = typeof cachedAlbums.$inferSelect;
